import React from "react";
import { Box, IconButton } from "@mui/material";
import { DarkBlueTooltip } from "@/components/styled";

const TooltipInfoIcon = ({ tooltipText }: { tooltipText: string }) => (
  <DarkBlueTooltip title={tooltipText} arrow enterDelay={300} leaveDelay={0}>
    <IconButton
      size="small"
      sx={{
        padding: "2px",
        marginLeft: "4px",
        "&:hover": {
          backgroundColor: "transparent",
        },
        position: "relative",
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          width: "16px",
          height: "16px",
          borderRadius: "50%",
          backgroundColor: "white",
          border: "1.5px solid black",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          fontWeight: "bold",
          color: "black",
        }}
      >
        i
      </Box>
    </IconButton>
  </DarkBlueTooltip>
);

export default TooltipInfoIcon;
